import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {worldEnum, internalPage, TAB_ENUM, productType} from './Constant';
import {
  getSelfCareData,
  getTrackerItems,
  getMyInvoices,
  Onboarding,
  internetProductsMerge,
  productsAndServicesResponse,
} from './SelfCareAsyncThunk';
import {stackOffsetExpand} from 'd3';
import EpiContext from '@episerver/spa-core/Spa';
import {AbroadSocType} from '../../Block/CellcomAbroadLobbyBlock/Shared/Models/AbroadPackageModels';
import {
  GetAbroadAdditionalServices,
  getCustomerAbroadPackages,
  updatePackage,
  removePackage,
  abroadRemoveAndAddSoc,
  getCustomerAbroadUsageDisplay,
  fetchPackagePopular,
  fetchPackagePopularMarket,
  addAddonToPackage,
  abroadRemoveAndAddSocFamily,
} from 'app/Components/Block/CellcomAbroadLobbyBlock/Shared/abroadThunk';

const initialState = {
  epiData: {
    worldType: TAB_ENUM.Main,
  },
  isFetchData: false,
  isFetchLoginData: false,
  selfCareData: {
    trackers: {
      orderedTrackerItems: [],
      isShowTracker: false,
      numOfItems: 0,
      firstInView: 0,
      showPopUp: false,
      isLoading: true,
      error: false,
      popUpType: '',
      popUpProps: {},
      firstItemShown: {},
      clickedActionUrl: '',
      requestSuccessfullyCompleted: false,
    },
    organizationState: {
      organizationCodeList: {},
      organizationName: '',
      organizationType: '',
      joinServiceLink: '',
      orgBannerDesktop: '',
      orgBannerMobile: '',
      desktopImageModeOne: '',
      mobileImageModeOne: '',
      adBannerDesktopImageModeTwo: '',
      adBannerMobileImageModeTwo: '',
      adBannerUrlModeTwo: '',
      trackerDesktopImageModeThree: '',
      trackerMobileImageModeThree: '',
      specialPackagesCellularList: {},
      organizationCoreProductData: {},
      organizationAdBannerDesktopImage: '',
      organizationAdBannerMobileImage: '',
      organizationAdBannerUrl: '',
      devicesToUpgradeList: {},
      hideFooterAndHeader: null,
    },
    invoices: [],
    coreProducts: [],
    collaborationApproval: false,
    isLoadingExtendedData: false,
    retainSubscriberOnLoad: false,
    page: 0,
    showPopUpOnTrackerInit: false,
    popupReasonOnTrackerInit: '',
  },
  page: internalPage.Main,
  subscribersByProduct: [],
  subscribersAbroadTabShown: false,
  subscribersAbroad: false,
  productsBySubscriber: null,
  selectedSubscriber: null,
  mainCustomerInfoCellular: {isBusiness: false, orgId: ''},
  packagesDetails: [],
  isFetchLoginData: false,
  worlds: {
    abroad: {
      abroadLobbyBlockId: null,
    },
  },
  selectedService: {},
  links: {
    updateSubscriberNameLink: '',
    updateContactDetailsLink: '',
  },
  otpExtendedFinished: false,
  chosenActionUrl: '',
  callbackAfterExtendedLogin: '',
};

const selfCarePageSlice = createSlice({
  name: 'selfcarePage',
  initialState: initialState,
  reducers: {
    resetPage: (state) => initialState,
    initPage: {
      reducer: (state, action) => {
        state.epiData = {...action.payload.epiData};
        const prevPathname = new URL(sessionStorage.getItem('prevFullUrl'))?.pathname;
        var pathSegments = window.location.pathname.split('/').filter(Boolean);
        pathSegments.pop();
        if (prevPathname?.includes(pathSegments.join('/'))) {
          state.retainSubscriberOnLoad = false;
        }
        state.isLoadingExtendedData = false;
      },
      prepare: (action) => {
        let payload = {};
        const epiData = {
          worldType: worldEnum[action.worldType.value],
        };

        payload.epiData = epiData;
        return {payload: payload};
      },
    },
    goToPage: (state, action) => {
      state.page = action.payload;
      window.scrollTo(0, 0);
    },
    setAbroadLobbyBlockId: (state, action) => {
      if (!state.worlds) {
        state.worlds = {};
      }
      if (!state.worlds.abroad) {
        state.worlds.abroad = {};
      }
      state.worlds.abroad.abroadLobbyBlockId = action.payload;
    },
    setSelectedSubscriber: (state, action) => {
      state.selectedSubscriber = action.payload;
    },
    updateNumOfMsgs: (state, action) => {
      state.selfCareData.trackers.firstInView = action.payload;
    },
    setOrganizationDataActionSelfCare: (state, action) => {
      state.organizationState = action.payload;
    },
    setCustomerTypeSelfCare: (state, action) => {
      state.customerType = action.payload;
    },
    setOrgIdSelfCare: (state, action) => {
      state.orgId = action.payload;
    },
    setChosenActionUrl: (state, action) => {
      state.chosenActionUrl = action.payload;
    },
    setPackageInfo: (state, action) => {
      const worldType = state.selectedSubscriber.productType;
      const updatedSubscribers = state.subscribersByProduct[worldType].map((sub) => {
        if (sub.productSubscriberNo === state.selectedSubscriber.productSubscriberNo) {
          return {
            ...sub,
            packageInfo: action.payload,
          };
        }
        return sub;
      });
      state.subscribersByProduct = {
        ...state.subscribersByProduct,
        [worldType]: updatedSubscribers,
      };
    },

    setSubscribersDetails: (state, action) => {
      var currentSubscriber = action.payload.cli ?? state.selectedSubscriber.productSubscriberNo;
      Object.keys(state.subscribersByProduct).forEach((worldType) => {
        state.subscribersByProduct[worldType] = state.subscribersByProduct[worldType].map((sub) => {
          if (sub.productSubscriberNo === currentSubscriber) {
            sub.productFirstName = action.payload.firstName;
            sub.productLastName = action.payload.lastName;
          }
          return sub;
        });
      });
      state.selectedSubscriber.productFirstName = action.payload.firstName;
      state.selectedSubscriber.productLastName = action.payload.lastName;
      return state;
    },
    setWorldType: (state, action) => {
      state.epiData.worldType = action.payload;
    },
    setPopUpProps: (state, action) => {
      state.selfCareData.trackers.popUpType = action.payload.popUpType;
      state.selfCareData.trackers.popUpProps = action.payload.popUpProps;
    },
    displayPopUp: (state, action) => {
      state.selfCareData.trackers.showPopUp = action.payload;
    },
    setSelectedService: (state, action) => {
      state.selectedService = action.payload;
    },
    setEpiData: (state, action) => {
      state.links = {
        ...state.links,
        updateContactDetailsLink: action.payload.updateContactDetailsLink.value,
        updateSubscriberNameLink: action.payload.updateSubscriberNameLink.value,
      };
    },
    refetchData: (state, action) => {
      state.isFetchData = false;
      state.isLoadingExtendedData = true;
    },
    setRetainSubscriberOnLoad: (state, action) => {
      state.retainSubscriberOnLoad = action.payload;
    },
     setCallbackAfterExtendedLogin: (state, action) => {
      state.callbackAfterExtendedLogin = action.payload;
    },
    setClickedActionUrl: (state, action) => {
      state.selfCareData.trackers.clickedActionUrl = action.payload;
    },
    getSubscriberDetails: (state, action) => {
      if (state.subscribersByProduct['Cellular']) {
        state.subscribersByProduct['Cellular'].map((sub) => {
          if (sub.productSubscriberNo === action.payload) {
            state.selectedSubscriber = sub;
          }
        });
      }
    },
    setSelfcareSubscriber: (state, action) => {
      var sub = state.subscribersByProduct['Cellular'].find((sub) => sub.productSubscriberNo == action.payload);
      state.selectedSubscriber = sub;
      state.retainSubscriberOnLoad = true;
    },

    saveToHistory: (state, action) => {
      return state;
    },

    updateAbroadPackageDate: (state, action) => {
      var newDate = action.payload.newDate;
      var socName = action.payload.socName;
      var oldDate = action.payload.oldDate;
      var subscriberNo = action.payload.subscriberNo;

      var subIndex = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, subscriberNo);
      if (subIndex !== -1) {
        var sub = state.subscribersByProduct[TAB_ENUM.Abroad][subIndex];

        if (sub.newAbroadPackage && socName == sub.newAbroadPackage?.socCode && oldDate == sub.newAbroadPackage?.startDate) {
          sub.newAbroadPackage = {socCode: socName, startDate: newDate};
          sub.abroadAddons = sub.abroadAddons.map((addon) => {
            return {...addon, startDate: newDate};
          });
        }
        return updateSubscriberState(state, TAB_ENUM.Abroad, subIndex, sub);
      }
    },
    removeAbroadPackageMsgBySub: (state, action) => {
      var subscriberNo = action.payload.subscriberNo;
      var subIndex = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, subscriberNo);
      if (subIndex !== -1) {
        const updatedSubscriber = {
          ...state.subscribersByProduct[TAB_ENUM.Abroad][subIndex],
          newAbroadPackage: null,
        };
        state.subscribersByProduct[TAB_ENUM.Abroad][subIndex] = updatedSubscriber;
        if (action.payload.subscriberNo == state.selectedSubscriber.productSubscriberNo) {
          state.selectedSubscriber = updatedSubscriber;
        }
      }
    },

    resetSocPackageRemoveStatus: (state, action) => {
      state.subscribersByProduct[TAB_ENUM.Abroad].forEach((sub) => {
        sub.abroadPackages = {...sub.abroadPackages, removePackageSucceded: null, updatePackageSucceded: null};
        return sub;
      });
      return state;
    },
    invalidateAbroadDataForSubscriber: (state, action) => {
      const subscriberNo = action.payload;
      var subIndex = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, subscriberNo);
      if (subIndex !== -1) {
        state.subscribersByProduct[TAB_ENUM.Abroad][subIndex].isFetchAbroadData = false;
        if (state.selectedSubscriber?.productSubscriberNo === subscriberNo) {
          state.selectedSubscriber.isFetchAbroadData = false;
        }
      }
    },
    setSubscribersAbroadTabShown: (state, action) => {
      state.subscribersAbroadTabShown = action.payload;
    },
    closePopUpOnTrackerInit: (state, action) => {
      state.selfCareData.showPopUpOnTrackerInit = false;
      state.selfCareData.popupReasonOnTrackerInit = '';
    },

    resetAllAbroadSubscribers: (state) => {
        const subscribers = state.subscribersByProduct[TAB_ENUM.Abroad];

        if (!subscribers || subscribers.length === 0) {
          return;
        }

        state.subscribersByProduct[TAB_ENUM.Abroad] = subscribers.map(sub =>
          resetAbroadSubscriberData({ ...sub })
        );
      },
  
    setReducedSocsForFamilyMember: (state, action) => {
      state.selectedSubscriber ={
          ...state.selectedSubscriber,
          selectedFamilyReducedSoc: action.payload.socCode,
       };

      state.retainSubscriberOnLoad = true;
      return state;
    },
  },


  extraReducers: {
    [getTrackerItems.fulfilled]: (state, action) => {
      return {...state, trackerState: {isLoading: true}};
    },
    [getSelfCareData.fulfilled]: (state, action) => {
      if (action.payload) {
        if (state.isLoadingExtendedData) {
          state.isLoadingExtendedData = false;
          state.otpExtendedFinished = true;
        }
        const {productsAndServicesDetails, ...rest} = action.payload;
        state.productsBySubscriber = productsAndServicesDetails;

        const productsAndServicesDetailsCopy = JSON.parse(JSON.stringify(productsAndServicesDetails)); //deep copy to avoid changing the original object
        let separatedProductsAndServicesData = productsAndServicesResponse(productsAndServicesDetailsCopy);
        mergeOnboardingDataAndProductsAndServices(state.subscribersByProduct, separatedProductsAndServicesData);
        state.selfCareData = {...state.selfCareData, ...rest};
        state.isFetchData = true;
        if (!state.selectedSubscriber && state.epiData.worldType === TAB_ENUM.Main) {
          var cellularList = state.subscribersByProduct[TAB_ENUM.Cellular];
          if (cellularList) state.selectedSubscriber = cellularList[0];
        }
        if (
          state.subscribersByProduct[TAB_ENUM.Abroad]?.filter(
            (subscriber) => subscriber.abroadInd === 'Y' || subscriber.abroadSocInd === 'Y',
          )?.length > 0
        ) {
          state.subscribersAbroad = true;
        }
      }
    },
    [getTrackerItems.fulfilled]: (state, action) => {
      const {orderedTrackerItems, numOfItems, error, shouldShowPopup, popupType} = action.payload;
      let isFinanceMessage = false;
      let isShowTracker = false;
      let getBanFinanceIssueType = orderedTrackerItems.find((x) => x._type == 'FinanceIssue');
      if (!getBanFinanceIssueType) {
        isShowTracker = true;
      } else {
        isShowTracker = true;
        isFinanceMessage = true;
      }
      if (error) {
        isShowTracker = false;
      }
      let firstItemShown = orderedTrackerItems[0];

      // setting the states:
      state.selfCareData.trackers.orderedTrackerItems = orderedTrackerItems;
      state.selfCareData.trackers.numOfItems = numOfItems;
      state.selfCareData.trackers.error = error;
      state.selfCareData.trackers.isFinanceMessage = isFinanceMessage;
      state.selfCareData.trackers.isShowTracker = isShowTracker;
      state.selfCareData.trackers.firstItemShown = firstItemShown;
      state.selfCareData.trackers.isLoading = false;
      state.selfCareData.trackers.requestSuccessfullyCompleted = true;
      state.selfCareData.showPopUpOnTrackerInit = shouldShowPopup;
      state.selfCareData.popupReasonOnTrackerInit = shouldShowPopup ? popupType : '';
    },
    [getTrackerItems.pending]: (state, action) => {
      state.selfCareData.trackers.requestSuccessfullyCompleted = false;
    },
    [getTrackerItems.rejected]: (state, action) => {
      state.selfCareData.trackers.requestSuccessfullyCompleted = false;
    },

    [getMyInvoices.fulfilled]: (state, action) => {},

    [Onboarding.fulfilled]: (state, action) => {
      if (action.payload) {
        state.isFetchData = false;
        state.isFetchLoginData = true;
        state.subscribersByProduct = action.payload.subscribersByProduct;
        state.customerInfo = action.payload.customerInfo;
        if (action.payload?.subscribersByProduct?.Cellular) {
          const contactSubscriber = action.payload?.subscribersByProduct?.Cellular[0];
          if (!state.retainSubscriberOnLoad) {
            state.selectedSubscriber = contactSubscriber;
          }
          state.mainCustomerInfoCellular.isBusiness = contactSubscriber?.isBusinness;
          state.mainCustomerInfoCellular.orgId = contactSubscriber?.orgId;
        }
      }
    },

    //abroad
    [getCustomerAbroadPackages.fulfilled]: (state, action) => {
      var subscriberNo = action.payload.validatedPhone;
      var subIndex = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, subscriberNo);
      if (subIndex !== -1) {
        var sub = state.subscribersByProduct[TAB_ENUM.Abroad][subIndex];
        var packages = action.payload.result.Body.item1;

        sub.abroadPackages = {
          status: action.meta.requestStatus,
          regularPackages: packages?.filter((pack) => !pack.isAutoPackage) ?? [],
          autoPackages: packages?.filter((pack) => pack.isAutoPackage) ?? [],
        };

        sub.isFetchAbroadData = true;
        sub.abroadAddons = action.payload.addons ?? sub.abroadAddons;
        return updateSubscriberState(state, TAB_ENUM.Abroad, subIndex, sub);
      }
    },
    [getCustomerAbroadUsageDisplay.fulfilled]: (state, action) => {
      var subscriberNo = action.payload.mobile;
      var subIndex = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, subscriberNo);
      if (subIndex !== -1) {
        var sub = state.subscribersByProduct[TAB_ENUM.Abroad][subIndex];
        sub.abroadUsage = {data: action.payload.Body, status: action.meta.requestStatus};
        return updateSubscriberState(state, TAB_ENUM.Abroad, subIndex, sub);
      }
    },
    [getCustomerAbroadUsageDisplay.pending]: (state, action) => {
      var subscriberNo = action.meta.arg.mobile;
      var subIndex = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, subscriberNo);
      if (subIndex !== -1) {
        var sub = state.subscribersByProduct[TAB_ENUM.Abroad][subIndex];
        sub.abroadUsage = {...sub.abroadUsage, status: action.meta.requestStatus};
        return updateSubscriberState(state, TAB_ENUM.Abroad, subIndex, sub);
      }
    },
    [abroadRemoveAndAddSoc.fulfilled]: (state, action) => {
      var subscriberNo = action.payload.mobile;
      var subIndex = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, subscriberNo);
      if (subIndex !== -1) {
        var sub = state.subscribersByProduct[TAB_ENUM.Abroad][subIndex];
        if (!action.payload.error && action.payload.Body?.isSuccess) {
          if (action.payload.isFamilyBundleEdit) {
            sub.newAbroadPackage = null;
          } else {
            sub.newAbroadPackage = action.payload.newPackage;
          }
          sub.abroadAddons = action.payload.Body.addonsUnderPackage;
          sub.abroadPackages = {
            status: '',
            ...sub.abroadPackages,
          };
          sub = resetAbroadSubscriberData(sub);
          resetFamilySubscribersData(action.payload?.Body?.successfulMembers, state);
        }
        // On failure, preserve abroadPackages so the component stays mounted and can show the error popup

        return updateSubscriberState(state, TAB_ENUM.Abroad, subIndex, sub);
      }
    },
    [GetAbroadAdditionalServices.fulfilled]: (state, action) => {
      var subscriberNo = action.payload.mobile;
      var subIndex = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, subscriberNo);
      if (subIndex !== -1) {
        var sub = state.subscribersByProduct[TAB_ENUM.Abroad][subIndex];
        let couponAddons = action.payload?.data?.Body?.couponAddons;
        if (couponAddons?.length > 0) {
          // Merge existing addons with coupon data and add new coupons
          const updatedAddons = [
            ...(sub.abroadAddons?.map((addon) => {
              const matchingCoupon = couponAddons.find((c) => c.socCode === addon.socCode);
              return {
                ...addon,
                permissions: matchingCoupon?.permissions,
                activationCode: matchingCoupon?.activationCode,
              };
            }) || []),
            ...couponAddons.filter((coupon) => !sub.abroadAddons?.some((addon) => addon.socCode === coupon.socCode)),
          ];
          sub.abroadAddons = updatedAddons;
        } else {
          sub.abroadAddons = sub.abroadAddons?.map((addon) => {
            return {...addon, isPurchased: false};
          });
        }
        return updateSubscriberState(state, TAB_ENUM.Abroad, subIndex, sub);
      }
    },
    [updatePackage.fulfilled]: (state, action) => {
      var res = action.payload;
      var subscriberNo = res.mobile;
      var subIndex = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, subscriberNo);
      if (subIndex !== -1) {
        var sub = state.subscribersByProduct[TAB_ENUM.Abroad][subIndex];
        if (res.Body?.isSuccess) {
          const oldDate = res.oldDate;
          const socName = res.socName.trim();
          const newDate = res.newDate;

          if (sub.newAbroadPackage && socName == sub.newAbroadPackage?.socCode && oldDate == sub.newAbroadPackage?.startDate) {
            sub.newAbroadPackage = {...sub.newAbroadPackage, socCode: socName, startDate: newDate};
            sub.abroadAddons = sub.abroadAddons.map((addon) => {
              return {...addon, startDate: newDate};
            });
          }
        } else {
          sub.abroadPackages = {...sub.abroadPackages, status: action.meta.requestStatus, updatePackageSucceded: false};
        }
        return updateSubscriberState(state, TAB_ENUM.Abroad, subIndex, sub);
      }
    },
    [removePackage.fulfilled]: (state, action) => {
      var subscriberNo = action.payload.mobile;
      var subIndex = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, subscriberNo);
      if (subIndex !== -1) {
        var sub = state.subscribersByProduct[TAB_ENUM.Abroad][subIndex];
        if (action.payload?.Header?.ReturnCode == '0' && action.payload?.Body?.isSuccess) {
          var socName = action.payload.socName.trim();
          var socType = action.payload.socType;
          var isAddon = action.payload.isAddon;
          var startDate = action.payload.startDate;
          if (!isAddon) {
            // remove indication of newAbroadPackage
            if (sub.newAbroadPackage && socName.trim() == sub.newAbroadPackage?.socCode && startDate == sub.newAbroadPackage?.startDate) {
              sub.newAbroadPackage = null;
            }
          }
          sub.abroadAddons = sub.abroadAddons?.map((addon) => {
            if (addon.socCode == socName || addon.parentSocCode == socName) {
              return {...addon, isPurchased: false};
            }
            return addon;
          });
          var currentSocToRemove = sub.abroadPackages?.regularPackages?.find(
            (pkg) => pkg.socName.trim() === socName.trim() && pkg.socEffactiveDate === startDate.trim(),
          );
          if (currentSocToRemove && currentSocToRemove.abroadPackageClient?.isFamilyBonus) {
            var SubGiveBonus = state.subscribersByProduct[TAB_ENUM.Abroad].findIndex((subscriber) => {
              if (subscriber.abroadPackages?.regularPackages) {
                return subscriber.abroadPackages.regularPackages.some((pkg) => {
                  return pkg.familyMembersWithPackages?.includes(subscriberNo);
                });
              }
              return false;
            });
            if (SubGiveBonus !== -1) {
              state.subscribersByProduct[TAB_ENUM.Abroad][SubGiveBonus].isFetchAbroadData = false;
            }
          }
          const existingAbroadPackages = sub.abroadPackages;
          sub = resetAbroadSubscriberData(sub);
          // Preserve regularPackages so SelfCareExistingPackage stays mounted long enough to show the success popup.
          // The actual data refresh happens when the user dismisses the popup.
          sub.abroadPackages = { ...existingAbroadPackages, removePackageSucceded: true, status: action.meta.requestStatus };
          // Block the auto-refetch in SelfCareAbroadCustomerExistingPackagesMain until
          // the user dismisses the success popup.
          sub.isFetchAbroadData = true;
        } else {
          sub.abroadPackages = {...sub.abroadPackages, status: action.meta.requestStatus, removePackageSucceded: false};
        }

        resetFamilySubscribersData(action.payload?.Body?.successfulMembers, state);
        return updateSubscriberState(state, TAB_ENUM.Abroad, subIndex, sub);
      }
    },
    [addAddonToPackage.fulfilled]: (state, action) => {
      var res = action.payload;
      var soc = res.soc;
      var subscriberNo = res.mobile;
      var subIndex = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, subscriberNo);
      if (subIndex !== -1) {
        var sub = state.subscribersByProduct[TAB_ENUM.Abroad][subIndex];
        if (res.Body.isSuccess) {
          sub.abroadAddons = sub.abroadAddons.map((addon) => {
            if (addon.socCode === soc) {
              // Get permissions from the current package and apply to addon
              if (sub.newAbroadPackage) {
                const permissions = sub.abroadPackages.regularPackages?.find(
                  (p) => p.socName.trim() === sub.newAbroadPackage.socCode.trim(),
                )?.permissions;
                return {...addon, isPurchased: true, permissions: permissions};
              }
            }
            return addon;
          });

          sub = resetAbroadSubscriberData(sub);
        } else {
          sub.abroadPackages = {...sub.abroadPackages, status: action.meta.requestStatus};
        }
        return updateSubscriberState(state, TAB_ENUM.Abroad, subIndex, sub);
      }
    },
    [fetchPackagePopularMarket.fulfilled]: (state, action) => {
      var subscriberNo = action.payload.mobile;
      if (subscriberNo) {
        var subIndex = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, subscriberNo);
        if (subIndex !== -1) {
          var sub = state.subscribersByProduct[TAB_ENUM.Abroad][subIndex];
          sub.packagesPopularMarket = {
            status: action.meta.requestStatus,
            data: {[action.payload.id]: action.payload.response},
          };
          return updateSubscriberState(state, TAB_ENUM.Abroad, subIndex, sub);
        }
      }
    },
    [abroadRemoveAndAddSocFamily.fulfilled]: (state, action) => {
      var subscriberNo = action.payload.mobile;
      var SubscriberNoParent = action.payload.SubscriberNoParent;
      var subIndex = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, subscriberNo);
      var newState = state;
      if (subIndex !== -1) {
        var sub = state.subscribersByProduct[TAB_ENUM.Abroad][subIndex];
        if (action.payload.Body?.isSuccess) {
          sub.newAbroadPackage = action.payload.newPackage;
          sub.abroadAddons = action.payload.Body?.addonsUnderPackage;
          sub.abroadPackages = {
            status: '',
            ...sub.abroadPackages,
          };
        }
        sub = resetAbroadSubscriberData(sub);
        newState = updateSubscriberState(state, TAB_ENUM.Abroad, subIndex, sub);
      }
      if (SubscriberNoParent) {
        var SubIndexParent = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, SubscriberNoParent);
        if (SubIndexParent !== -1) {
          state.subscribersByProduct[TAB_ENUM.Abroad][SubIndexParent].isFetchAbroadData = false;
          if (SubscriberNoParent == state.selectedSubscriber.productSubscriberNo) {
            state.selectedSubscriber = state.subscribersByProduct[TAB_ENUM.Abroad][SubIndexParent];
            newState = updateSubscriberState(
              newState,
              TAB_ENUM.Abroad,
              SubIndexParent,
              state.subscribersByProduct[TAB_ENUM.Abroad][SubIndexParent],
            );
          }
        }
      }
      return newState;
    },
    [fetchPackagePopularMarket.pending]: (state, action) => {
      var subscriberNo = action.meta.arg.mobile;
      var subIndex = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, subscriberNo);
      if (subIndex !== -1) {
        var sub = state.subscribersByProduct[TAB_ENUM.Abroad][subIndex];
        sub.packagesPopularMarket = {...sub.packagesPopularMarket, status: action.meta.requestStatus};
        return updateSubscriberState(state, TAB_ENUM.Abroad, subIndex, sub);
      }
    },
    [getCustomerAbroadPackages.pending]: (state, action) => handleAbroadPackagesPending(state, action),
    [addAddonToPackage.pending]: (state, action) => handleAbroadPackagesPending(state, action),
    [updatePackage.pending]: (state, action) => handleAbroadPackagesPending(state, action),
    [removePackage.pending]: (state, action) => {},
    [updatePackage.rejected]: (state, action) => {
      var subscriberNo = action.meta.arg.mobile;
      var subIndex = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, subscriberNo);
      if (subIndex !== -1) {
        var sub = state.subscribersByProduct[TAB_ENUM.Abroad][subIndex];
        sub.abroadPackages = {...sub.abroadPackages, status: action.meta.requestStatus, updatePackageSucceded: false};
        return updateSubscriberState(state, TAB_ENUM.Abroad, subIndex, sub);
      }
    },

    [removePackage.rejected]: (state, action) => {
      var subscriberNo = action.meta.arg.mobile;
      var subIndex = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, subscriberNo);
      if (subIndex !== -1) {
        var sub = state.subscribersByProduct[TAB_ENUM.Abroad][subIndex];
        sub.abroadPackages = {...sub.abroadPackages, status: action.meta.requestStatus, removePackageSucceded: false};
        return updateSubscriberState(state, TAB_ENUM.Abroad, subIndex, sub);
      }
    }
  },
});

export const {
  setSelectedSubscriber,
  setWorldType,
  updateNumOfMsgs,
  setSubscribersDetails,
  setPackageInfo,
  resetPage,
  initPage,
  goToPage,
  setPopUpProps,
  displayPopUp,
  setSelectedService,
  refetchData,
  setAbroadLobbyBlockId,
  setEpiData,
  setClickedActionUrl,
  setOrganizationDataActionSelfCare,
  setCustomerTypeSelfCare,
  setOrgIdSelfCare,
  setChosenActionUrl,
  setRetainSubscriberOnLoad,
  getSubscriberDetails,
  setSelfcareSubscriber,
  updateAbroadPackageDate,
  removeAbroadPackageMsgBySub,
  saveToHistory,
  resetSocPackageRemoveStatus,
  invalidateAbroadDataForSubscriber,
  setSubscribersAbroadTabShown,
  closePopUpOnTrackerInit,
  resetAllAbroadSubscribers,
  setCallbackAfterExtendedLogin,
  setReducedSocsForFamilyMember
} = selfCarePageSlice.actions;

export default selfCarePageSlice.reducer;

function mergeOnboardingDataAndProductsAndServices(subscribersByProduct, productsAndServicesDetails) {
  //union between  onboarding data and productsAndServicesDetails
  Object.keys(subscribersByProduct).forEach((productType1) => {
    if (productsAndServicesDetails[productType1]) {
      if (productType1 == productType.Internet) {
        subscribersByProduct[productType1] = productsAndServicesDetails[productType1].map((product1) => {
          const product2 = subscribersByProduct[productType1]?.find(
            (p) => p.productSubscriberNo?.trim() == product1.subscriberNumber?.trim(),
          );
          if (product2) {
            return {...product1, ...product2};
          }
          return product1;
        });
      } else {
        subscribersByProduct[productType1] = subscribersByProduct[productType1].map((product1) => {
          const product2 = productsAndServicesDetails[productType1].find(
            (p) => p.subscriberNumber?.trim() == product1.productSubscriberNo?.trim(),
          );
          if (product2) {
            return {...product1, ...product2};
          }
          return product1;
        });
      }
    }
  });
}

function findSubscriberIndexByProductType(state, productType, subscriberNo = null) {
  var subscriberTofind = subscriberNo ?? state.selectedSubscriber?.productSubscriberNo;
  if (subscriberTofind && state.subscribersByProduct[productType]) {
    {
      var subIndex = state.subscribersByProduct[productType].findIndex((sub) => sub.productSubscriberNo === subscriberTofind);
      return subIndex;
    }
  }
  return -1;
}

function updateSubscriberState(state, productType, subIndex, newSubscriberData) {
  state.subscribersByProduct[productType][subIndex] = newSubscriberData;
  if (
    newSubscriberData.productSubscriberNo == state.selectedSubscriber.productSubscriberNo &&
    state.epiData.worldType === TAB_ENUM.Abroad
  ) {
    state.selectedSubscriber ={ ...state.selectedSubscriber, ...newSubscriberData};
  }
  return state;
}
function handleAbroadPackagesPending(state, action) {
  const subscriberNo = action.meta.arg?.mobile ?? action.meta.arg?.phoneNumber;
  if (subscriberNo) {
    var subIndex = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, subscriberNo);
    if (subIndex !== -1) {
      var sub = state.subscribersByProduct[TAB_ENUM.Abroad][subIndex];
      sub.abroadPackages = {...sub.abroadPackages, status: action.meta.requestStatus};
      return updateSubscriberState(state, TAB_ENUM.Abroad, subIndex, sub);
    }
  }
}
function resetAbroadSubscriberData(sub) {
  sub.abroadPackages = null;
  sub.packagesPopularMarket = null;
  sub.isFetchAbroadData = false;
  return sub;
}

function resetFamilySubscribersData(familyMembers, state){
            if (Array.isArray(familyMembers)) {
              familyMembers.forEach((memberPhone) => {
                var memberIndex = findSubscriberIndexByProductType(state, TAB_ENUM.Abroad, memberPhone);
                if (memberIndex !== -1) {
                  var memberSub = state.subscribersByProduct[TAB_ENUM.Abroad][memberIndex];
                  memberSub = resetAbroadSubscriberData(memberSub);
                  updateSubscriberState(state, TAB_ENUM.Abroad, memberIndex, memberSub);
                }
              });
            }
}
